import { createFileRoute } from "@tanstack/react-router";

import MyAssignments from "~/pages/MyAssignments";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute(
  "/_private/record-labelling/my-assignments",
)({
  staticData: ROUTE_STATIC.myAssignments,
  component: MyAssignments,
});
